import { Button, StyledSVG, Path } from './styles';

/**
 * Componente para controle
 * @param {Function} onclick função a ser executada para retrair o item 
 * @returns {ReactComponentElement} 
 */
const RetractableButton = ({onclick}) => {
    return (
        <Button onClick={onclick}>
            <StyledSVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 10">
                <Path
                    id="Vector"
                    d="M9.73315 9.47292L16.2615 2.91854C16.4058 2.77484 16.5203 2.60386 16.5985 2.41549C16.6767 2.22711 16.7169 2.02506 16.7169 1.82099C16.7169 1.61692 16.6767 1.41487 16.5985 1.2265C16.5203 1.03812 16.4058 0.867151 16.2615 0.723445C15.973 0.435531 15.5828 0.273926 15.176 0.273926C14.7692 0.273926 14.379 0.43553 14.0905 0.723445L8.63997 6.19573L3.18943 0.723445C2.90095 0.43553 2.51071 0.273925 2.10394 0.273925C1.69718 0.273925 1.30694 0.43553 1.01846 0.723445C0.875754 0.867888 0.762856 1.03919 0.686233 1.22753C0.609611 1.41588 0.570772 1.61755 0.571945 1.82099C0.570772 2.02444 0.609611 2.22611 0.686233 2.41445C0.762856 2.60279 0.875754 2.7741 1.01846 2.91854L7.54678 9.47292C7.68992 9.61781 7.86021 9.73281 8.04783 9.81129C8.23546 9.88977 8.43671 9.93017 8.63997 9.93017C8.84323 9.93017 9.04447 9.88977 9.23210 9.81129C9.41973 9.73281 9.59002 9.61781 9.73315 9.47292Z"
                />
            </StyledSVG>
        </Button>
    );
};

export default RetractableButton;